const mediaItems = [
  {
    title: '2026暑期档大片抢先看',
    subtitle: '多部国产巨制陆续上线，动作、喜剧、科幻全覆盖',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20scene%20with%20dramatic%20golden%20lighting%2C%20summer%20blockbuster%20aesthetic%2C%20warm%20amber%20and%20sunset%20tones%2C%20film%20production%20quality%2C%20dark%20cinematic%20atmosphere%2C%20no%20visible%20text%2C%20luxurious%20movie%20theater%20vibe&width=800&height=450&seq=mahua-media-01&orientation=landscape',
    tag: '最新上线',
    tagColor: 'bg-accent-500',
  },
  {
    title: '高分悬疑剧《迷雾追踪》全集上线',
    subtitle: '豆瓣8.7分，演技派阵容倾情演绎烧脑剧情',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20scene%20with%20foggy%20atmosphere%2C%20dark%20moody%20lighting%2C%20warm%20filtered%20light%20through%20mist%2C%20suspenseful%20film%20aesthetic%2C%20deep%20shadows%20and%20amber%20highlights%2C%20no%20text&width=800&height=450&seq=mahua-media-02&orientation=landscape',
    tag: '热播中',
    tagColor: 'bg-primary-500',
  },
  {
    title: '热门综艺《欢乐喜剧人》新季开播',
    subtitle: '笑点密集不断，豪华嘉宾阵容引爆周末欢笑',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20stage%20lighting%20variety%20show%20atmosphere%2C%20warm%20colorful%20spotlight%20effects%2C%20entertainment%20show%20production%20aesthetic%2C%20joyful%20celebratory%20vibe%2C%20golden%20and%20amber%20stage%20lights%2C%20dark%20background%20contrast&width=800&height=450&seq=mahua-media-03&orientation=landscape',
    tag: '推荐',
    tagColor: 'bg-primary-500',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            精选内容
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            每日精选优质影视内容，好片看不完
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-medium text-background-50 ${item.tagColor}`}>
                  {item.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-foreground-900 group-hover:text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}